import React from 'react';
import { stylesheet } from 'typestyle';
import { EnvironmentOutlined } from '@ant-design/icons';
import { Tabs } from 'antd';
import { LinkOutlined } from '@ant-design/icons';

import { ListFixedHeader } from '@src/components';
import { NewForgeExperienceAlert } from '@src/components/new-forge-experience-alert';
import { useFormatMessage } from '@src/i18n';

import { FindSection } from './find-section';
import { GenerateSection } from './generate-section';
import { useMasterSiteId } from '@src/utils/hooks';
import { services } from '@src/services';

const { TabPane } = Tabs;

const openCustomizationPlayground = (siteId: string) => {
  const { MAD_API_ENV } = services.envService.getEnvironmentalVariables();
  const domainNameSuffix = MAD_API_ENV === 'production' ? '' : `-${MAD_API_ENV}`;
  window.open(
    `https://cdn${domainNameSuffix}.ingrid.com/delivery-tracking-playground/index.html?siteId=${siteId}`,
    '_blank'
  );
};

export const TrackingPlayground = () => {
  const formatMessage = useFormatMessage();
  const siteId = useMasterSiteId();
  const [activeTab, setActiveTab] = React.useState('generate');

  const switchTab = (tab: string) => {
    if (tab === 'configuration') {
      openCustomizationPlayground(siteId);
      return;
    }
    setActiveTab(tab);
  };

  return (
    <>
      <NewForgeExperienceAlert path="/tracking-numbers" />
      <ListFixedHeader
        title={formatMessage('TRACKING_PLAYGROUND')}
        IconComponent={EnvironmentOutlined}
        showSearch={false}
      />
      <Tabs
        type="card"
        className={styles.tabs}
        destroyInactiveTabPane
        activeKey={activeTab}
        onChange={switchTab}
      >
        <TabPane tab="Generate" key="generate">
          <GenerateSection />
        </TabPane>
        <TabPane tab="Find" key="find">
          <FindSection />
        </TabPane>
        <TabPane
          tab={
            <>
              <LinkOutlined /> Configuration and Branding
            </>
          }
          key="configuration"
        />
      </Tabs>
    </>
  );
};

const styles = stylesheet({
  tabs: {
    $nest: {
      '.ant-tabs-content-holder': {
        overflow: 'auto',
      },
    },
  },
});
